import React, { useState } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { getRemotedbUrl, i18nIntl, isNotEmpty } from '../../lib/ep';
import { AlertTypes, SecurityUserAction } from './SecurityCenter.js';

import { SquaredButton } from '../builder/ActionButton';
import ButtonCollection from '../builder/ButtonCollection';

import RibbonCollection from '../ui_items/RibbonCollection';
import ActionLink from '../builder/ActionLink';
import FloatingLayer from '../builder/FloatingLayer';
import SingleRegisteredEntry from '../backend/SingleRegisteredEntry';

const date_format = 'DD MMM YYYY, HH:mm';
const max_items_default = 50;

export const ParticipantDetailLayer = ({ login_id, ...props }) => {
	const [ display_detail_layer, setDisplayDetailLayer ] = useState(false);

	const openDetailLayer = () => {
		$.get(getRemotedbUrl(`/users/get_full_view_data/${props.promotion_id}/${login_id}`), (res) => {
			if(res.status == '1') {
				setDisplayDetailLayer(res.data);
			}
		}, 'JSON');
	};

	return (
		<>
			<ActionLink
				onClick={() => openDetailLayer(login_id)}
			>{props?.name ?? participant_id}</ActionLink>

			{(display_detail_layer !== false) && (
				<FloatingLayer backButton={() => setDisplayDetailLayer(false)}>
					<div class="without_actions">
						<SingleRegisteredEntry
							basename={props.basename}
							{...display_detail_layer}
							userAction={(a,b,c,d)=>SecurityUserAction(a,b,c,d,props.promotion_id)}
						/>
					</div>
				</FloatingLayer>
			)}
		</>
	)
};

export const UsersTable = injectIntl(({ items, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const max_items = props?.max_items ?? max_items_default;

	if(items.length == 0) {
		return (
			<div class="gui_participations_list is_builder">
				<div>{i18n("There are no users")}.</div>
			</div>
		)
	}

	return (
		<>
			{(items.length > max_items) && (
				<p class="gui_not_in_bottom">
					<FormattedMessage id="Only the first {max} items are displayed." values={{ max:max_items }} />
				</p>
			)}

			<div class="gui_participations_list is_builder">
				<table class='single_user_participations' cellSpacing="0" cellPadding="0" style={{width:'100%'}}>
					<thead>
						<tr>
							<th style={{ width:'8%' }} />

							<th class="gui_text_align_start" style={{ width:'230px' }}>{i18n("***Name")}</th>

							<th class="gui_text_align_start">{i18n("Login information")}</th>

							<th class="gui_text_align_start" style={{ width:'180px' }}>{i18n("Date")}</th>
						</tr>
					</thead>

					<tbody>
						{items.slice(0, max_items).map((item, i) => {
							return (
								<tr key={`user_by_ip_${i}`}>
									<td class="ranking_pos">#{i + 1}</td>

									<td class="gui_text_align_start">
										{(item.login_id && item.promotion_id) ? (
											<ParticipantDetailLayer
												basename={props.basename}
												login_id={item.login_id}
												promotion_id={item.promotion_id}
												name={item.name}
												userAction={() => {
												}}
											/>
										):(
											<strong>{`${item.first_name} ${item.last_name}`}</strong>
										)}
									</td>

									<td class="gui_text_align_start">
										{item?.email ?? '-'}
									</td>

									<td class="gui_text_align_start">{EPDateFormat(item.created, date_format)}</td>
								</tr>
							)
						})}
					</tbody>
				</table>
			</div>
		</>
	)
});

export const DomainsTable = injectIntl(({ items, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const max_items = props?.max_items ?? max_items_default;
	const alerts = props?.alerts ?? [];

	if(items.length == 0) {
		return (
			<div class="gui_participations_list is_builder">
				<div>{i18n("There are no results.")}</div>
			</div>
		)
	}

	return (
		<>
			{(items.length > max_items) && (
				<p class="gui_not_in_bottom">
					<FormattedMessage id="Only the first {max} items are displayed." values={{ max:max_items }} />
				</p>
			)}

			<div class="gui_participations_list is_builder">
				<table class='single_user_participations' cellSpacing="0" cellPadding="0" style={{width:'100%'}}>
					<thead>
						<tr>
							<th style={{ width:'8%' }} />

							<th class="gui_text_align_start" style={{ width:'46%' }}>{i18n("domain", 'ucfirst')}</th>

							<th class="gui_text_align_start">{i18n("Total")}</th>
						</tr>
					</thead>

					<tbody>
						{items.slice(0, max_items).map((item, i) => {
							const domain_alerts = alerts.filter((al) => al.domain == (item?.domain ?? ''));

							return (
								<tr key={`user_by_ip_${i}`}>
									<td class="ranking_pos">#{i + 1}</td>

									<td class="gui_text_align_start">
										<strong>{`${item.domain}`}</strong>
									</td>

									<td class="gui_text_align_start">
										{item.total}
									</td>
								</tr>
							)
						})}
					</tbody>
				</table>
			</div>
		</>
	)
});

export const IpsTable = injectIntl(({ items, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const max_items = props?.max_items ?? max_items_default;
	const alerts = props?.alerts ?? [];

	if(items.length == 0) {
		return (
			<div class="gui_participations_list is_builder">
				<div>{i18n("There are no results.")}</div>
			</div>
		)
	}

	return (
		<>
			{(items.length > max_items) && (
				<p class="gui_not_in_bottom">
					<FormattedMessage id="Only the first {max} items are displayed." values={{ max:max_items }} />
				</p>
			)}

			<div class="gui_participations_list is_builder">
				<table class='single_user_participations' cellSpacing="0" cellPadding="0" style={{width:'100%'}}>
					<thead>
						<tr>
							<th style={{ width:'8%' }} />

							<th class="gui_text_align_start" style={{ width:'230px' }}>{i18n("IP")}</th>

							<th class="gui_text_align_start" style={{ width:'230px' }}>{i18n("Number of alerts")}</th>

							<th class="gui_text_align_start">{i18n("Total")}</th>
						</tr>
					</thead>

					<tbody>
						{items.slice(0, max_items).map((item, i) => {
							const ip_alerts = alerts.filter((al) => al.ip == (item?.ip ?? ''));

							return (
								<tr key={`user_by_ip_${i}`}>
									<td class="ranking_pos">#{i + 1}</td>

									<td class="gui_text_align_start">
										<strong>{`${item.ip}`}</strong>
									</td>

									<td class="gui_text_align_start">
										{(ip_alerts.length > 0) ? ip_alerts.length : '-'}
									</td>

									<td class="gui_text_align_start">
										{item.total}
									</td>
								</tr>
							)
						})}
					</tbody>
				</table>
			</div>
		</>
	)
});

export const AlertsTable = injectIntl(({ items, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const max_items = props?.max_items ?? max_items_default;
	
	const loaded = props?.loaded ?? true;
	if(!loaded){
		return (
			<div class="relative_to_container">
				<Spinner
					_class={{other:'gui_pos_rel_important'}}
					force_bg={true}
				>Loading alerts</Spinner>
			</div>
		)
	}

	if(items.length == 0) {
		return (
			<div class="gui_participations_list is_builder">
				<div>{i18n("There are no results.")}</div>
			</div>
		)
	}

	return (
		<>
			{(items.length > max_items) && (
				<p class="gui_not_in_bottom">
					<FormattedMessage id="Only the first {max} items are displayed." values={{ max:max_items }} />
				</p>
			)}

			<div class="gui_participations_list is_builder">
				<table class='single_user_participations' cellSpacing="0" cellPadding="0" style={{width:'100%'}}>
					<thead>
						<tr>
							<th style={{ width:'8%' }} />

							<th class="gui_text_align_start" style={{ width:'180px' }}>{i18n("Date")}</th>

							<th class="gui_text_align_start" style={{ width:'180px' }}>{i18n("Type")}</th>

							<th class="gui_text_align_start">{i18n("Information")}</th>

						</tr>
					</thead>

					<tbody>
						{items.slice(0, max_items).map((item, i) => {
							const type = AlertTypes.find((t) => (t.k == item.type));

							return (
								<tr key={`alert_by_ip_${i}`}>
									<td class="ranking_pos">#{i + 1}</td>

									<td class="gui_text_align_start">{EPDateFormat(item.created, date_format)}</td>

									<td class="gui_text_align_start">
										{(type) ? (
											<RibbonCollection
												items={[{
													title:type.v,
													color:type.color,
													is_html:true,
												}]}
											/>
										) : (
											<span>-</span>
										)}
									</td>

									<td class="gui_text_align_start">
										<span>{(isNotEmpty(item, 'information')) ? item.information : '-'}</span>
									</td>

								</tr>
							)
						})}
					</tbody>
				</table>
			</div>
		</>
	)
});